import store from '@/store';
import { isWeightedProduct } from '@/objects/Product';

/**
 * Get subtotal price of an order, which excludes the vat price
 * @param {object} order order object
 * @returns subtotal price
 */
function getSubtotalPrice(order) {
  let price = 0.0;
  // Products
  order.Products.forEach((product) => {
    let amount = product.Quantity;
    if (isWeightedProduct(product)) {
      amount = product.Quantity / product.StepSize;
    }
    price +=
      amount * (product.ItemRetailPrice - product.ItemRetailVatPrice);

    // price += product.ItemTotalRetailPrice - product.ItemTotalRetailVatPrice;
  });

  // Price categories
  order.PriceCategories.forEach((priceCategory) => {
    price
      += (priceCategory.PriceCategoryPrice
        - priceCategory.PriceCategoryVatPrice)
      * priceCategory.Quantity;
  });

  return price;
}

function getTotalDiscount(order) {
  let totalDiscountPrice = 0.0;
  const { isProfUser } = store.getters;

  // Discounts from growth vitamin cards
  if (order.Discounts !== undefined) {
    order.Discounts.forEach((discount) => {
      if (isProfUser) {
        totalDiscountPrice += discount.Price - discount.VatPrice;
      } else {
        totalDiscountPrice += discount.Price;
      }
    });
  }

  // Discounts from products
  order.Products.forEach(product => {
    let amount = product.Quantity;
    if (isWeightedProduct(product)) {
      amount = product.Quantity / product.StepSize;
    }

    if (isProfUser) {
      let totalRetailPriceExclVat =
        amount * (product.ItemRetailPrice - product.ItemRetailVatPrice);

      // const totalRetailPriceExclVat =
      //   product.ItemTotalRetailPrice - product.ItemTotalRetailVatPrice;
      totalDiscountPrice +=
        product.ItemTotalPrice -
        product.ItemTotalVatPrice -
        totalRetailPriceExclVat;
    } else {
      let totalRetailPriceInclVat = amount * product.ItemRetailPrice;
      // const totalRetailPriceInclVat = product.ItemTotalRetailPrice;
      totalDiscountPrice +=
        product.ItemTotalPrice - totalRetailPriceInclVat;
    }
  });

  return totalDiscountPrice;
}

export {
  getSubtotalPrice,
  getTotalDiscount,
};
